import { styled } from '@mui/material';

import Page from '@/components/Page/index.ts';
import { getActiveCompetition, competitionWinnersQuery } from '@/lib/api/requests.ts';
import { getQueryClient } from '@/lib/query-client-context.ts';

import type { Route } from './+types/LandingPage';
import { Footer } from './_sections/Footer.tsx';
import { RulesSection } from './_sections/RulesSection.tsx';
import { StatsSection } from './_sections/StatsSection.tsx';
import { TimerSection } from './_sections/TimerSection.tsx';
import { TopSection } from './_sections/TopSection.tsx';
import { WinnersSection } from './_sections/WinnersSection.tsx';

const Root = styled('div')({
  width: '100%',
  backgroundColor: 'white',
});

export async function loader({ context }: Route.LoaderArgs) {
  const queryClient = getQueryClient(context);
  const competitions = await queryClient.query(competitionWinnersQuery());
  const competition = competitions.find((c) => c.slug === 'january_open_2025_campaign');
  const allWinners = [...competitions].reverse().flatMap((d) => d.winners);
  return {
    winners: competition?.winners,
    allWinners,
    activeCompetition: await getActiveCompetition(competitions),
  };
}

export default function LandingPage({ loaderData }: Route.ComponentProps) {
  return (
    <Page title="Gjeldfri januar trekning">
      <Root>
        <TopSection winners={loaderData.winners} activeCompetition={loaderData.activeCompetition} />
        <TimerSection activeCompetition={loaderData.activeCompetition} />
        <WinnersSection allWinners={loaderData.allWinners} />
        <RulesSection activeCompetition={loaderData.activeCompetition} />
        <StatsSection activeCompetition={loaderData.activeCompetition} />
        <Footer />
      </Root>
    </Page>
  );
}
